<template>
  <div class="model-task-table_container">
    <table-custom
      ref="taskTable"
      class="model-task-table"
      :data="tableData"
      selection
      row-key="rtId"
      :expand-row-keys="expands"
      :tree-props="{children: 'subTasks', hasChildren: 'hasChildren'}"
      :selected-list="checkedList"
      column-width="400"
      :disabled="(isSingle && checkedList.length > 0) || checkedList.length >= limit"
      :disabled-list="[...disabledList, ...relatedTasks]"
      default-expand-all
      :height="tableHeight"
      column-label="pc_biz_jq_lbl_taskName"
      @selection-change="handleSelectionChange"
    >
      <yxt-table-column
        :label="$t('pc_biz_udp_lbl_description')"
        show-overflow-tooltip
        prop="taskDesc"
      >
        <template slot-scope="{row}">
          {{ row.taskDesc || '--' }}
        </template>
      </yxt-table-column>
    </table-custom>
    <gwnl-pager
      :pager="pager"
      @searchData="getModelDuty"
    />
  </div>
</template>

<script>
import tableCustom from './tableCustom';
import { getDutyFromModel, getRelatedTasksByProjectId, getDutyFromProject } from '../service.js';
import resizeTable from '../../../user-selector/mixins/resizeTable';
import GwnlPager from './pager';

export default {
  name: '',
  components: { tableCustom, GwnlPager},
  mixins: [resizeTable],
  props: {
    selectedData: {
      type: Array,
      default: () => []
    },
    skillLevelSwitch: {
      type: Number,
      default: 1
    },
    skillSelection: {
      type: Array,
      default: () => {
        return [];
      }
    },
    allSkillSelection: {
      type: Array,
      default: () => {
        return [];
      }
    },
    rtModelId: String,
    isSingle: {
      type: Boolean,
      default: false
    },
    disabledList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    limit: {
      type: Number,
      default: Infinity
    },
    projectId: {
      type: String,
      required: true
    },
    scene: {
      type: Number,
      default: 0 // 0 talent 1 奇点 2 高阶
    }
  },
  data() {
    return {
      loading: false,
      keyword: '',
      skillCatalogId: '',
      expands: [], // 要展开的行，数值的元素是row的key值
      tableData: [],
      checkedList: [],
      relatedTasks: [],
      commonList: [],
      majorList: [],
      refTable: 'taskTable',
      pager: {
        pages: 0,
        pageSize: 20,
        total: 0,
        limit: 20,
        offset: 0
      },
      selected: [],
      skillSelectionMap: {},
      allSkillSelectionMap: {},
      noLevelSelectMap: {},
      tableHeight: 0
    };
  },
  watch: {
    selectedData: {
      immediate: true,
      handler: function(val) {
        this.checkedList = val.filter(item => item.type === 2);
      }
    }
  },
  computed: {
    isSp() {
      return this.scene === 1;
    }
  },
  mounted() {
    this.init(1);
  },
  methods: {
    init() {
      this.getRelatedTasks();
      this.getModelDuty();
    },
    getModelDuty(current) {
      this.loading = true;
      let params = {
        limit: this.pager.pageSize,
        offset: current
          ? (current - 1) * this.pager.pageSize
          : this.pager.offset
      };
      const id = this.isSp ? this.projectId : this.rtModelId;
      const func = this.isSp ? getDutyFromProject(id, params) : getDutyFromModel(id);
      func
        .then((res) => {
          this.loading = false;
          this.tableData = this.formatData(res.datas);
          if (!this.rtlId) {
            this.isEmpty = !res.datas.length;
          }

          this.pager.pages = res.paging.pages;
          this.pager.offset = res.paging.offset;
          this.pager.total = res.paging.count;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getRelatedTasks() {
      getRelatedTasksByProjectId(this.projectId).then((res) => {
        if (res && res.length > 0) {
          const result = Array.from(new Set(res));
          this.relatedTasks = result.map(id => ({ 'rtId': id }));
        }
      }).catch((err) => {
        console.error(err);
      });
    },
    handleSelectionChange(val) {
      let arr = Array.isArray(val) && val.map(d => {
        return {
          ...d,
          id: d.rtId, // 职责任务Id
          type: 2
        };
      });
      this.checkedList = val;
      this.$emit('change', arr);
    },
    formatData(data) {
      let tasks = Array.isArray(data) && data.map(item => {
        item.id = item.rtlId;
        item = {
          ...item,
          subTasks: this.formatData(item.subTasks)
        };
        return item;
      });
      return tasks;
    },
    update() {
      this.$refs.taskTable.clearSelection();
    }
  }
};
</script>

<style lang="scss" scoped>
.model-task-table_container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .model-task-table {
    flex: 1;
    overflow: hidden;
  }
}

.select-kng-points__content {
  .gwnl-selectskill__level {
    width: 100%;
    margin-bottom: -1px;
    padding: 14px 24px 14px 56px;
    border-bottom: 1px solid #ddd;

    .gwnl-selectskill__level-skill-name {
      display: flex;
      width: 290px;
    }

    .gwnl-selectskill__level-skill-description {
      width: calc(100% - 290px);
    }
  }
}

.select-function__table {
  ::v-deep .yxt-table__row {
    cursor: pointer;
  }

  ::v-deep .yxt-table__expand-icon {
    ::v-deep .yxt-icon-arrow-right::before {
      color: #d8d8d8;
      font-size: 14px;
      content: '\e791';
    }
  }

  ::v-deep .yxt-table__expanded-cell {
    padding: 0;
  }

  .gwnl-skill-table-tr__checkbox {
    margin: 0 8px 0 -8px;
  }

  .gwnl-flex-width {
    width: calc(100% - 22px);
  }

  .gwnl-flex-tags {
    flex: none;
    width: auto;
  }
}

.toggle {
  color: #436bff;
}
</style>
